import nextSvg from '../../../assets/svg/arrow-right.svg';
import prevSvg from '../../../assets/svg/arrow-left.svg';

export default Array.from( document.querySelectorAll( '.people-slider' ) ).map( ( gallerySlider ) => {
	const wrap   = gallerySlider.querySelector('.people-slider__wrap');
	const items  = gallerySlider.querySelector('.people-slider__items');
	const slides = Array.from( gallerySlider.querySelectorAll('.people-slide') );

	wrap.classList.add('swiper-container');
	items.classList.add('swiper-wrapper');
	slides.forEach(gallerySlider => gallerySlider.classList.add('swiper-slide'));

	return new window.Swiper( wrap, {
		direction: 'horizontal',
		autoHeight: false,
		speed: 600,
		spaceBetween: 0,
		slidesPerView: 4,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		pagination: false,
		watchSlidesVisibility: true,
		breakpoints: {
			700: {
			  slidesPerView: 1,
			},
			768: {
			  slidesPerView: 3,
			},
			992: {
			  slidesPerView: 4,
			}
		  }
	} );
} );